
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.071 12.929a9.963 9.963 0 00-3.8-2.384 5.78 5.78 0 002.51-4.764A5.788 5.788 0 0010 0a5.788 5.788 0 00-5.781 5.781 5.78 5.78 0 002.51 4.764 9.962 9.962 0 00-3.8 2.384A9.935 9.935 0 000 20h1.563c0-4.652 3.785-8.438 8.437-8.438 4.652 0 8.438 3.786 8.438 8.438H20a9.935 9.935 0 00-2.929-7.071zM10 10a4.224 4.224 0 01-4.219-4.219A4.224 4.224 0 0110 1.563a4.224 4.224 0 014.219 4.218A4.224 4.224 0 0110 10z","fill":"#979797"}})])
          )
        }
      }
    